<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header"
             style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container v-if="isLoading" fluid class="mt--7">
            <card>
                Loading...
            </card>
        </b-container>
        <b-container v-else fluid class="mt--7">
        <card>
            <b-row>
                <b-col>
                    <h1>Site details:</h1>
                    <base-input label="Name" placeholder="Name" v-model="site.name" />
                    <base-input label="Google name" placeholder="Google name" v-model="site.google_name" />
                    <base-input label="Type" placeholder="Type">
                        <b-dropdown :text="site.type===undefined || site.type==null ? 'Not selected' : popularitySiteTypes[site.type]" variant="outline-light">
                            <b-dropdown-item v-for="(type,index) in popularitySiteTypes" :key="index+'_popsitetype'" @click="site.type=index;$forceUpdate()">{{type}}</b-dropdown-item>
                            <b-dropdown-item @click="site.type=undefined;;$forceUpdate()">Not selected</b-dropdown-item>
                        </b-dropdown>
                    </base-input>
                </b-col>
                <b-col>
                    <h1>&nbsp;</h1>
                    <base-input label="Address" placeholder="Address" v-model="site.address" />
                    <base-input label="Google address" placeholder="Google address" v-model="site.google_address" />
                    <base-input label="Country" placeholder="Country">
                        <b-dropdown v-if="countries!==null" :text="site.country===undefined ? 'Not selected' : countries[site.country].name" variant="outline-light">
                            <b-dropdown-item v-for="(country,index) in countries" :key="index+'_popsitecountry'" @click="site.country=country.id;$forceUpdate()">{{country.name}}</b-dropdown-item>
                            <b-dropdown-item @click="site.country=undefined;$forceUpdate()">Not selected</b-dropdown-item>
                        </b-dropdown>
                    </base-input>
                    <base-input label="Average only" placeholder="Average only">
                        <base-checkbox v-model="site.average_only" />
                    </base-input>
                </b-col>
                <b-col>
                    <button class="btn btn-success" @click="saveSite()">{{id==='new' ? 'Create' : 'Save'}}</button>
                    <base-input label="ORG ID" placeholder="ORG ID" v-model="site.org_id" />
                    <base-input label="Place ID" placeholder="Place ID" v-model="site.place_id" />
                    <base-input label="City" placeholder="City" v-model="site.city" />
                </b-col>
            </b-row>
        </card>
        <card v-if="id!=='new'">
            <h2>Charts</h2>
            <div class="chart-headers d-flex align-items-start">
                <div class="popularity-date-filters">
                    <base-input label="Start date" :appendIcon="'ni ni-calendar-grid-58 text-blue'">
                        <date-picker v-model="startDate" :config="datePickerOptions" @dp-change="getCharts()" />
                    </base-input>
                    <base-input label="End date" :appendIcon="'ni ni-calendar-grid-58 text-blue'">
                        <date-picker v-model="endDate" :config="datePickerOptions" @dp-change="getCharts()" />
                    </base-input>
                </div>
                <div>
                    <base-input label="Show current charts" placeholder="Show current charts">
                        <base-checkbox v-model="showCurrentCharts" />
                    </base-input>
                </div>
                <div class="d-flex">
                    <div class="mr-3">
                        <label class="form-control-label" for="Weekly">Weekly</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Weekly" aria-label="Weekly" v-model.number="weeklyPopularityInput">
                            <div class="input-group-append">
                                <base-button class="py-1" icon type="success" @click="convertRatioWithWeekly(weeklyPopularityInput)">
                                    <span class="btn-inner--icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-calculator" viewBox="0 0 20 20">
                                            <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                                            <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
                                        </svg>
                                    </span>
                                </base-button>
                            </div>
                        </div>
                    </div>
                    <div class="mr-3">
                        <label class="form-control-label" for="Monthly">Monthly</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Monthly" aria-label="Monthly" v-model.number="monthlyPopularityInput">
                            <div class="input-group-append">
                                <base-button class="py-1" icon type="success" @click="convertRatioWithMonthly(monthlyPopularityInput)">
                                    <span class="btn-inner--icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-calculator" viewBox="0 0 20 20">
                                            <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                                            <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
                                        </svg>
                                    </span>
                                </base-button>
                            </div>
                        </div>
                    </div>
                    <div class="mr-3">
                        <label class="form-control-label" for="Annually">Annually</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Annually" aria-label="Annually" v-model.number="annuallyPopularityInput">
                            <div class="input-group-append">
                                <base-button class="py-1" icon type="success" @click="convertRatioWithAnnually(annuallyPopularityInput)">
                                    <span class="btn-inner--icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-calculator" viewBox="0 0 20 20">
                                            <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                                            <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
                                        </svg>
                                    </span>
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
                <base-button class="mt-4" type="success" @click="exportChart()">Export charts</base-button>
            </div>
            <div v-if="chartsInitialized" class="charts-container">
                <div v-if="showCurrentCharts" class="chart-view mt-5">
                    <div v-if="currentChartLoading">
                        <h4>Current chart loading...</h4>
                    </div>
                    <h4 v-else>Current chart:</h4>
                    <canvas id="current_heatmap" ref="current_heatmap" :width="heatmapWidth" :height="heatmapHeight" @click="heatmapClicked"/>
                    <canvas id="current_line" ref="current_line" class="mt-3" :width="lineChartWidth" :height="lineChartHeight" />
                </div>
                
                <div class="chart-view mt-5">
                    <div v-if="averageChartLoading">
                        <h4>Average chart loading...</h4>
                    </div>
                    <h4 v-else>Average chart:</h4>
                    <canvas id="average_heatmap" ref="average_heatmap" :width="heatmapWidth" :height="heatmapHeight" @click="heatmapClicked" />
                    <canvas id="average_line" ref="average_line" class="mt-3" :width="lineChartWidth" :height="lineChartHeight" />
                    
                </div>
                <div class="mt-5" v-if="weeklyPopularity || monthlyPopularity ||annuallyPopularity">
                    <div>
                        <h4>Weekly</h4>
                        <p>{{weeklyPopularity}}</p>
                    </div>
                    <div>
                        <h4>Monthly</h4>
                        <p>{{monthlyPopularity}}</p>
                    </div>
                    <div>
                        <h4>Annually</h4>
                        <p>{{annuallyPopularity}}</p>
                    </div>
                </div>
            </div>
        </card>
        </b-container>
        <modal :show.sync="showPopulationRatioPopup" size="lg">
            <h4 slot="header">Population ratio input</h4>
            <p>Please insert exact values to convert ratios for {{hourlyPopularityRatioModalTable.ratioType}} chart</p>
            <!-- <p>{{hourlyPopularityRatioModalTable}}</p> -->
            <b-table :items="hourlyPopularityRatioModalTable.data">
                <template #cell(day)="row">
                    <b-dropdown :text="hourlyPopularityRatioModalTable.days[row.item.day]" variant="outline-light">
                        <b-dropdown-item v-for="(day,index) in hourlyPopularityRatioModalTable.days" :key="index+'_popratioday'" @click="row.item.day=index;refreshRatios();$forceUpdate()">{{day}}</b-dropdown-item>
                    </b-dropdown>
                </template>
                <template #cell(hour)="row">
                    <b-dropdown :text="hourlyPopularityRatioModalTable.hours[row.item.hour]" variant="outline-light">
                        <b-dropdown-item v-for="(hour,index) in hourlyPopularityRatioModalTable.hours" :key="index+'_popratiohour'" @click="row.item.hour=index;refreshRatios();$forceUpdate()">{{hour}}</b-dropdown-item>
                    </b-dropdown>
                </template>
                <template #cell(max)="row">
                    {{hourlyPopularityRatioModalTable.maxInDays[row.item.day]}}
                </template>
                <template #cell(value)="row">
                    <base-input v-model.number="row.item.value" type="number" />
                </template>
                <template #cell(delete)="row">
                    <base-button icon type="info" @click="hourlyPopularityRatioModalTable.data.splice(row.index,1);$forceUpdate();">
                        <span class="btn-inner--icon">
                            <i class="ni ni-fat-remove" />
                        </span>
                    </base-button>
                </template>
            </b-table>
            <base-button icon type="success" @click="hourlyPopularityRatioModalTable.data.push({day:null,hour:null,ratio:null,value:null,delete:null})">
                <span class="btn-inner--icon">
                    <i class="ni ni-fat-add"/>
                </span>
            </base-button>

            <template slot="footer">
                <base-button type="danger" class="ml-auto" @click="showPopulationRatioPopup = false">Cancel</base-button>
                <base-button type="success" @click="convertRatioWithHourly()">Convert</base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";
import * as xlsx from 'xlsx/xlsx.mjs';

import {Table,TableColumn} from 'element-ui'

import chartjs from 'chart.js';
import heatmap from 'chart.heatmap.js';

const PopularitySiteRepository = RepositoryFactory.get('popularity_site')
const PopularityDataRepository = RepositoryFactory.get('popularity_data')
const CountryRepository = RepositoryFactory.get('country')

export default {
    props:{
        id:String
    },
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    watch:{
        showCurrentCharts:{
            handler(newVal,oldVal){
                if(newVal && this.chartDataKey) {
                    this.$nextTick().then(() => {
                        this.initCurrentCharts();
                    });
                    this.$forceUpdate();
                }
            },
            immediate: true
        }
    },
    data(){
        return {
            isLoading:true,
            currentChartLoading:true,
            averageChartLoading:true,

            chartsInitialized: false,

            showCurrentCharts: false,

            site:null,
            chartDataKey: null,
            chartData:{
                raw:{
                    current:null,
                    average:null,
                },
                converted:{
                    current:null,
                    average:null,
                }
            },

            heatmapOptions:{
                colors:['rgba(245,247,250,0.9)','rgba(205,33,38,0.9)'],
                labelScale: 0.3,
                labelFontColor: 'rgba(1, 1, 1,0.9)'
            },
            heatmapWidth:400,
            heatmapHeight:200,
            averageHeatmap:null,
            currentHeatmap:null,


            lineChartOptions:{
                hoverBackgroundColor:'rgb(0,0,0)'
            },
            lineChartWidth:400,
            lineChartHeight:200,
            averageLineChart:null,
            currentLineChart:null,

            startDate:null,
            endDate:null,

            datePickerOptions:{
                format: 'DD/MM/YYYY', // Burası degisirse parseDateFilters metodu da degismeli
                useCurrent: false,
                showClear: true,
                showClose: true,
                showTodayButton:true,
            },

            countries:null,

            showPopulationRatioPopup:false,
            hourlyPopularityRatioModalTable:{
                hours:[],
                days:[],
                ratioType:null,
                data:[],
            },

            weeklyPopularityInput: null,
            monthlyPopularityInput: null,
            annuallyPopularityInput: null,

            weeklyPopularity: null,
            monthlyPopularity: null,
            annuallyPopularity: null,
        }
    },
    created(){
        CountryRepository.get().then((response) => {
            var r=response.data;
            this.countries={}
            for(var i in r){
                var c=r[i]
                this.countries[c.id]=c
            }

            if(this.id==='new'){
                this.site={average_only:true}
                this.isLoading=false;
            }
            else{
                PopularitySiteRepository.getWithId(this.id).then((response) => {
                    this.site=response.data[0];
                    this.isLoading=false;
                })

                this.getCharts();
            }
        })
        
    },
    methods:{
        parseHeatmapData(data){
            var dayColors=[
                'rgb(255, 17, 0)',
                'rgb(255, 119, 0)',
                'rgb(255, 221, 0)',
                'rgb(183, 255, 0)',
                'rgb(0, 255, 162)',
                'rgb(0, 123, 255)',
                'rgb(132, 0, 255)'
            ]
            var parsedData={
                labels:['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
                datasets:[]
            }

            for(var i in this.weekdays){
                var weekday=this.weekdays[i];
                var d=[];
                for(var _ in parsedData.labels){
                    d.push(0);
                }
                parsedData.datasets.push({
                    label:weekday,
                    backgroundColor:'rgba(255,255,255,0)',
                    borderColor:dayColors[i-1],
                    pointBackgroundColor:dayColors[i-1],
                    data:d
                });
            }

            for(var i in data){
                var item=data[i];
                parsedData.datasets[item.week_day-1].data[item.hour]=parseInt(item.avg_popularity)
            }

            var removeIndexes=[]

            for(var i=0;i<parsedData.labels.length;i++){
                var isZero=true;
                for(var j in this.weekdays){
                    j--;
                    if(parsedData.datasets[j].data[i]!==0){
                        isZero=false;
                        break
                    }
                }
                if(isZero){
                    removeIndexes.push(i);
                }
            }
            removeIndexes.sort((a,b) => b-a);
            for(var i=0;i<removeIndexes.length;i++){
                var index=removeIndexes[i];
                parsedData.labels.splice(index,1)
                for(var j in this.weekdays){
                    j--;
                    parsedData.datasets[j].data.splice(index,1)
                }
            }

            return parsedData;
        },
        async resetCharts(){
            var charts=[this.averageHeatmap,this.averageLineChart,this.currentHeatmap,this.currentLineChart]
            for(var i in charts){
                var chart=charts[i]
                if(chart!==null){
                    chart.destroy();
                }
            }

            this.averageHeatmap = null;
            this.averageLineChart = null;
            this.currentHeatmap = null;
            this.currentLineChart = null;

            // Canvas taglerini tamamen ucurup tekrar olusturması icin
            this.chartsInitialized = false;
            await this.$nextTick();
            this.chartsInitialized = true;
            await this.$nextTick();
        },
        initCharts(){
            this.initCurrentCharts();
            this.initAverageCharts();
        },
        initCurrentCharts(){
            if(!this.showCurrentCharts) return;

            this.chartsInitialized = true;
            this.currentChartLoading = true;

            this.$nextTick().then(() => {
                this.currentHeatmap=new heatmap(
                    this.$refs.current_heatmap.getContext('2d')
                ).HeatMap(
                    this.chartData[this.chartDataKey].current, this.heatmapOptions
                );

                this.currentLineChart=new chartjs.Chart(
                    this.$refs.current_line.getContext('2d'),
                    {
                        type:'line',
                        data:this.chartData[this.chartDataKey].current,
                        options:this.lineChartOptions
                    }
                )

                var width = Math.floor(this.$refs.current_line.parentElement.offsetWidth / 2);
                var height = Math.floor(width / 2);

                this.currentLineChart.resize(width, height);
                this.currentHeatmap.resize(width, height);

                this.currentChartLoading = false;
            })
        },
        initAverageCharts(){
            this.chartsInitialized = true;
            this.averageChartLoading=true;

            this.$nextTick().then(() => {
                this.averageHeatmap=new heatmap(
                    this.$refs.average_heatmap.getContext('2d')
                ).HeatMap(
                    this.chartData[this.chartDataKey].average, this.heatmapOptions
                );

                this.averageLineChart=new chartjs.Chart(
                    this.$refs.average_line.getContext('2d'),
                    {
                        type:'line',
                        data:this.chartData[this.chartDataKey].average,
                        options:this.lineChartOptions
                    }
                )

                var width = Math.floor(this.$refs.average_line.parentElement.offsetWidth / 2);
                var height = Math.floor(width / 2);

                this.averageLineChart.resize(width, height);
                this.averageHeatmap.resize(width, height);

                this.averageChartLoading=false;
            })
        },
        async getCharts(){
            if(this.startDate===null || this.endDate===null){
                this.currentChartLoading=false;
                this.averageChartLoading=false;
                return;
            }
            this.currentChartLoading=true;
            this.averageChartLoading=true;

            await this.resetCharts();

            // var startDate=new Date(this.startDate)
            // var endDate=new Date(this.endDate)

            var startDate=this.startDate;
            var endDate=this.endDate;

            var payload={
                id:this.id,
                create_date__gte:startDate,
                create_date__lte:endDate,
                current_value:'all',
                charts:{
                    hourly_weekdays_average:['week_day','hour'],
                }
            }
            payload=this.parseDateFilters(payload)
            PopularityDataRepository.getChart(payload).then((response) => {
                var data=response.data
                var currentData=data.current.hourly_weekdays_average;
                var averageData=data.average.hourly_weekdays_average;

                this.chartData.raw.current=this.parseHeatmapData(currentData);
                this.chartData.raw.average=this.parseHeatmapData(averageData);

                this.chartDataKey = "raw"
                this.initCharts();
            })
        },
        parseDateFilters(filters){
            var dates=['create_date__gte','create_date__lte']
            for(var i in dates){
                var date=dates[i]

                if(filters[date]===null || filters[date]===undefined)
                delete filters[date];
                else{
                    filters[date]=filters[date].split('/');
                    filters[date]=`${filters[date][2]}-${filters[date][1]}-${filters[date][0]}`
                }
            }

            return filters
        },
        saveSite(){
            if(this.site.id===undefined){
                
                PopularitySiteRepository.post(this.site).then((response) => {
                    this.$router.push({name:'popularity_detail',params:{id:response.data.id}});
                    this.$notify({
                        message: 'Site created: '+this.site.name,
                        type: 'success',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true,
                    })  
                })
            }
            else
                PopularitySiteRepository.put(this.id,this.site).then((response) => {
                    this.$notify({
                        message: 'Site saved: '+this.site.name,
                        type: 'success',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true,
                    })  
                })
        },
        heatmapClicked(e){
            var clickedHeatmapID=e.srcElement.id
            var clickedBox=null
            var ratioType=null
            if(clickedHeatmapID==='current_heatmap'){
                clickedBox = this.currentHeatmap.getBoxAtEvent(e);
                ratioType='Current'
            }
            else{
                clickedBox = this.averageHeatmap.getBoxAtEvent(e);
                ratioType = 'Average'
            }
            if(clickedBox.value===0)
                return

            var dayIndex=null;
            var hourIndex=null;
            var days=[];
            var maxInDays=[];

            for(var i in this.chartData.raw[ratioType.toLowerCase()].labels){
                if(this.chartData.raw[ratioType.toLowerCase()].labels[i]===clickedBox.label){
                    hourIndex=parseInt(i);
                    break;
                }
            }
            for(var i in this.chartData.raw[ratioType.toLowerCase()].datasets){
                if(this.chartData.raw[ratioType.toLowerCase()].datasets[i].label===clickedBox.datasetLabel){
                    dayIndex=parseInt(i);
                }
                days.push(this.chartData.raw[ratioType.toLowerCase()].datasets[i].label);
                maxInDays.push(Math.max(...(this.chartData.raw[ratioType.toLowerCase()].datasets[i].data)))
            }
            this.hourlyPopularityRatioModalTable={
                days:days,
                hours:this.copyObject(this.chartData.raw[ratioType.toLowerCase()].labels),
                ratioType:ratioType,
                maxInDays:maxInDays,
                data:[
                    {
                        day:dayIndex,
                        hour:hourIndex,
                        ratio:this.chartData.raw[ratioType.toLowerCase()].datasets[dayIndex].data[hourIndex],
                        max:null,
                        value:null,
                        delete:null,
                    }
                ]
            }
            this.showPopulationRatioPopup=true;
        },
        refreshRatios(){
            var ratioType=this.hourlyPopularityRatioModalTable.ratioType.toLowerCase()
            for(var i in this.hourlyPopularityRatioModalTable.data){
                var dayIndex=this.hourlyPopularityRatioModalTable.data[i].day;
                var hourIndex=this.hourlyPopularityRatioModalTable.data[i].hour;

                if(dayIndex===null || dayIndex===undefined || hourIndex===null || hourIndex===undefined ){
                    continue
                }

                this.hourlyPopularityRatioModalTable.data[i].ratio=this.chartData.raw[ratioType].datasets[dayIndex].data[hourIndex]
            }
        },
        copyChartData(copyFromKey, copyToKey){
            var dataset=this.chartData[copyFromKey]

            this.chartData[copyToKey]={
                current:{
                    datasets:[],
                    labels:this.copyObject(dataset.current.labels),
                },
                average:{
                    datasets:[],
                    labels:this.copyObject(dataset.average.labels),
                }
            }

            var datasetNames=['current','average'];

            for(var i in datasetNames){
                var datasetName=datasetNames[i];

                for(var j in dataset[datasetName].datasets){
                    var subDataset=dataset[datasetName].datasets[j];
                    var subDataset={
                        backgroundColor:subDataset.backgroundColor,
                        borderColor:subDataset.borderColor,
                        label:subDataset.label,
                        pointBackgroundColor:subDataset.pointBackgroundColor,
                        data:this.copyObject(subDataset.data)
                    }
                    this.chartData[copyToKey][datasetName].datasets.push(subDataset);
                }
            }
        },
        async convertRatioWithHourly(){
            var sum=0;
            var count=0;
            for(var i in this.hourlyPopularityRatioModalTable.data){
                var data=this.hourlyPopularityRatioModalTable.data[i];

                if(["",null,undefined].includes(data.value))
                    continue
                
                count++;
                sum+=(data.value/data.ratio);
            }
            var percentValue=sum/count;

            this.copyChartData('raw','converted')

            var weeklyRatioSum=0;

            for(var j in this.chartData.raw.current.datasets){
                for(var i in this.chartData.raw.current.datasets[j].data){
                    this.chartData.converted.current.datasets[j].data[i]=Math.floor(percentValue*this.chartData.raw.current.datasets[j].data[i]);
                }
            }

            for(var j in this.chartData.raw.average.datasets){
                for(var i in this.chartData.raw.average.datasets[j].data){
                    this.chartData.converted.average.datasets[j].data[i]=Math.floor(percentValue*this.chartData.raw.average.datasets[j].data[i]);
                    weeklyRatioSum+=this.chartData.raw.average.datasets[j].data[i];
                }
            }

            await this.resetCharts();
            this.chartDataKey="converted";
            this.initCharts();

            this.weeklyPopularity = Math.floor(weeklyRatioSum * percentValue)
            this.weeklyPopularityInput = this.weeklyPopularity;

            this.monthlyPopularity = Math.floor(this.weeklyPopularity * 52 / 12)
            this.monthlyPopularityInput = this.monthlyPopularity;

            this.annuallyPopularity = Math.floor(this.monthlyPopularity * 12)
            this.annuallyPopularityInput = this.annuallyPopularity;

            this.showPopulationRatioPopup=false;
        },
        async convertRatioWithWeekly(weeklyPopularity){
            if(weeklyPopularity==='' || weeklyPopularity===null || weeklyPopularity===undefined){
                this.$notify({
                    message: 'Please enter a value',
                    type: 'danger',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                })
                return;
            }

            this.weeklyPopularityInput = null;
            this.monthlyPopularityInput = null;
            this.annuallyPopularityInput = null;
            
            var currentPopularitySum=0;
            var averagePopularitySum=0;
            for(var j in this.chartData.raw.current.datasets){
                for(var i in this.chartData.raw.current.datasets[j].data){
                    currentPopularitySum+=this.chartData.raw.current.datasets[j].data[i];
                }
            }

            for(var j in this.chartData.raw.average.datasets){
                for(var i in this.chartData.raw.average.datasets[j].data){
                    averagePopularitySum+=this.chartData.raw.average.datasets[j].data[i];
                }
            }

            var currentWeeklyRatio = weeklyPopularity/currentPopularitySum;
            var averageWeeklyRatio = weeklyPopularity/averagePopularitySum;

            this.copyChartData('raw','converted')

             for(var j in this.chartData.raw.current.datasets){
                for(var i in this.chartData.raw.current.datasets[j].data){
                    this.chartData.converted.current.datasets[j].data[i]=Math.floor(currentWeeklyRatio*this.chartData.raw.current.datasets[j].data[i]);
                }
            }

            for(var j in this.chartData.raw.average.datasets){
                for(var i in this.chartData.raw.average.datasets[j].data){
                    this.chartData.converted.average.datasets[j].data[i]=Math.floor(averageWeeklyRatio*this.chartData.raw.average.datasets[j].data[i]);
                }
            }

            await this.resetCharts()
            this.chartDataKey = "converted";
            this.initCharts();

            this.weeklyPopularity = Math.floor(weeklyPopularity);
            this.weeklyPopularityInput = this.weeklyPopularity;

            this.monthlyPopularity = Math.floor(this.weeklyPopularity * 52 / 12);
            this.monthlyPopularityInput = this.monthlyPopularity;

            this.annuallyPopularity = Math.floor(this.monthlyPopularity * 12);
            this.annuallyPopularityInput = this.annuallyPopularity;
        },
        convertRatioWithMonthly(monthlyPopularity){
            if(monthlyPopularity==='' || monthlyPopularity===null || monthlyPopularity===undefined){
                this.$notify({
                    message: 'Please enter a value',
                    type: 'danger',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                })
                return;
            }

            this.convertRatioWithWeekly(monthlyPopularity*12/52);
        },
        convertRatioWithAnnually(annuallyPopularity){
            if(annuallyPopularity==='' || annuallyPopularity===null || annuallyPopularity===undefined){
                this.$notify({
                    message: 'Please enter a value',
                    type: 'danger',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                })
                return;
            }

            this.convertRatioWithMonthly(annuallyPopularity/12);
        },
        exportChart(){
            var currentDatetime = new Date()
            var filename=`${this.site.name}_${currentDatetime.getFullYear()}-${currentDatetime.getMonth()+1}-${currentDatetime.getDate()}_${currentDatetime.getHours()}-${currentDatetime.getMinutes()}-${currentDatetime.getSeconds()}.xlsx`;

            var workBook=xlsx.utils.book_new();

            var hasData=false;
            for(var chartKey in this.chartData){
                for(var dataKey in this.chartData[chartKey]){
                    if(this.chartData[chartKey][dataKey]===null || this.chartData[chartKey][dataKey]===undefined)
                        continue;

                    var data=[['day','hour','value']];

                    for(var i in this.chartData[chartKey][dataKey].datasets){
                        var day=this.chartData[chartKey][dataKey].datasets[i].label;
                        for(var j in this.chartData[chartKey][dataKey].labels){
                            hasData=true;
                            var hour=this.chartData[chartKey][dataKey].labels[j];
                            data.push([day,hour,this.chartData[chartKey][dataKey].datasets[i].data[j]]);
                        }
                    }
                    var workSheet=xlsx.utils.aoa_to_sheet(data);
                    xlsx.utils.book_append_sheet(workBook,workSheet,`${chartKey}-${dataKey}`);
                }
            }
            if(hasData){
                xlsx.writeFile(workBook,filename);
            }
            else{
                this.$notify({
                    message: 'No data to export',
                    type: 'danger',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                });
            }
        }
    }
}
</script>

<style>

.popularity-date-filters{
    display: flex;
    flex-direction: row;
}

.popularity-date-filters > * {
    margin-right: 10px;
}

.charts-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.chart-headers {
    display:flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
}
</style>